(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sh-cross-sell"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sh-cross-sell')) {
    customElements.define(
      'sh-cross-sell',
      class ShCrossSell extends HTMLElement {
        connectedCallback() {
          if (this.__shReady) return;
          this.__shReady = true;
          this.pending = '';
          this.pendingOffer = null;
          this.onSubmit = this.onSubmit.bind(this);
          this.onAdded = this.onAdded.bind(this);
          this.onError = this.onError.bind(this);
          this.onClick = this.onClick.bind(this);
          this.onKeydown = this.onKeydown.bind(this);
          this.onCartEvent = this.onCartEvent.bind(this);
          this.onPointerDown = this.onPointerDown.bind(this);
          this._cartLockTimers = [];

          document.addEventListener('pointerdown', this.onPointerDown, true);
          document.addEventListener('submit', this.onSubmit, true);
          document.addEventListener('ajaxProduct:added', this.onAdded);
          document.addEventListener('ajaxProduct:error', this.onError);
          document.addEventListener('cart:updated', this.onCartEvent);
          this.addEventListener('click', this.onClick);

          this.patchDrawer();
          this.loadSwiper();
          this.fetchCart();
          if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
            this.unsubscribeCart = theme.pubsub.subscribe(
              theme.pubsub.PUB_SUB_EVENTS.cartUpdate,
              this.onCartEvent
            );
          }
          if (!this.bindCartApps()) {
            const timer = window.setInterval(() => {
              if (this.bindCartApps()) window.clearInterval(timer);
            }, 250);
            window.setTimeout(() => window.clearInterval(timer), 20000);
          }
        }

        disconnectedCallback() {
          if (this._moving) return;
          document.removeEventListener('pointerdown', this.onPointerDown, true);
          document.removeEventListener('submit', this.onSubmit, true);
          document.removeEventListener('ajaxProduct:added', this.onAdded);
          document.removeEventListener('ajaxProduct:error', this.onError);
          document.removeEventListener('cart:updated', this.onCartEvent);
          document.removeEventListener('keydown', this.onKeydown);
          this.clearCartLockTimers();
          if (this.unsubscribeCart) this.unsubscribeCart();
          if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
          }
          this.__shReady = false;
        }

        isShToken(value) {
          return /^sh[-_]/i.test(String(value || ''));
        }

        isShScope(el) {
          let node = el;
          while (node && node !== document.body && node !== document.documentElement) {
            if (node.nodeType === 1) {
              if (this.isShToken(node.id)) return true;
              const className = typeof node.className === 'string' ? node.className : '';
              if (className) {
                const tokens = className.split(/\s+/);
                for (let i = 0; i < tokens.length; i++) {
                  if (this.isShToken(tokens[i])) return true;
                }
              }
            }
            node = node.parentElement;
          }
          return false;
        }

        getFormFromTrigger(el) {
          if (!el) return null;
          if (el.form) return el.form;
          const formId = el.getAttribute('form');
          if (formId) return document.getElementById(formId);
          return el.closest('form');
        }

        isAddTrigger(el) {
          if (!el || !el.matches) return false;
          return el.matches('[name="add"], .product-form__submit, #sh-main-atc, .sh-cross-sell__add');
        }

        isMainForm(form) {
          if (!form || this.isUpsellForm(form)) return false;
          return this.isShScope(form);
        }

        isMainTrigger(el) {
          if (!el) return false;
          const form = this.getFormFromTrigger(el);
          if (this.isUpsellForm(form) || el.closest('.sh-cross-sell__add-form')) return false;
          return this.isShScope(el);
        }

        isUpsellForm(form) {
          return Boolean(form && form.getAttribute('data-sh-cross-sell') === 'upsell');
        }

        armAdd(kind, offer) {
          this.pending = kind;
          this.pendingOffer = offer || null;
          window.__shCrossSellSkipDrawer = true;
          this.keepDrawerClosed();
        }

        onPointerDown(event) {
          const trigger = event.target.closest('button, [type="submit"], [name="add"]');
          if (!this.isAddTrigger(trigger)) return;
          const form = this.getFormFromTrigger(trigger);
          if (this.isUpsellForm(form) || trigger.closest('.sh-cross-sell__add-form')) {
            this.armAdd('upsell', trigger.closest('.swiper-slide'));
            return;
          }
          if (this.isMainTrigger(trigger)) {
            this.armAdd('main');
          }
        }

        onSubmit(event) {
          const form = event.target;
          if (!(form instanceof HTMLFormElement)) return;
          const trigger = event.submitter || form;
          if (this.isUpsellForm(form)) {
            this.armAdd('upsell', form.closest('.swiper-slide'));
            return;
          }
          if (this.isMainTrigger(trigger) || this.isMainForm(form)) {
            this.armAdd('main');
          }
        }

        onAdded(event) {
          if (this._handlingAdd) return;
          this._handlingAdd = true;
          window.setTimeout(() => {
            this._handlingAdd = false;
          }, 1000);

          let kind = this.pending;
          const offer = this.pendingOffer;
          this.pendingOffer = null;
          this.pending = '';

          if (kind === 'main') {
            if (this.hasOffers()) this.open();
            else this.openCart(this.cartUrl());
            this.fetchCart();
            return;
          }
          if (kind === 'upsell') {
            this.hideOffer(offer);
            if (this.hasOffers()) {
              this.keepDrawerClosed();
              return;
            }
            this.openCart(this.cartUrl());
          }
        }

        onError() {
          this.pending = '';
          this.pendingOffer = null;
          this.clearCartLockTimers();
          window.__shCrossSellSkipDrawer = false;
        }

        hasOffers() {
          return this.offerCount() > 0;
        }

        offerCount() {
          return this.querySelectorAll('.swiper-slide:not([hidden])').length;
        }

        getItemProductId(item) {
          if (!item) return '';
          if (item.product_id) return item.product_id;
          if (item.productId) return item.productId;
          if (item.product && item.product.id) return item.product.id;
          return '';
        }

        onCartEvent(event) {
          const cart = (event && event.cart) || (event && event.detail && event.detail.cart);
          if (cart && Array.isArray(cart.items)) {
            this.applyCart(cart);
            return;
          }
          this.fetchCart();
        }

        fetchCart() {
          return fetch('/cart.js', {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' }
          })
            .then((response) => response.json())
            .then((cart) => {
              this.applyCart(cart);
              return cart;
            })
            .catch(() => null);
        }

        applyCart(cart) {
          if (!cart || !Array.isArray(cart.items)) return;

          const inCart = new Set();
          cart.items.forEach((item) => {
            const id = this.getItemProductId(item);
            if (id) inCart.add(String(id));
          });

          this.querySelectorAll('[data-sh-cs-product-id]').forEach((slide) => {
            const hide = inCart.has(String(slide.dataset.shCsProductId || ''));
            slide.hidden = hide;
          });

          this.syncSingleLayout();
          this.syncDots();
        }

        syncDots() {
          const dots = this.querySelector('[data-sh-cs-pagination]');
          if (dots) dots.hidden = this.offerCount() < 2;
        }

        hideOffer(slide) {
          if (!slide) return;
          slide.hidden = true;
          this.syncSingleLayout();
          this.syncDots();
        }

        syncSingleLayout() {
          const single = this.offerCount() <= 1;
          this.classList.toggle('is-single', single);
          if (!this.swiper) return;
          this.swiper.params.slidesPerView = single ? 1 : 1.12;
          this.swiper.params.spaceBetween = single ? 0 : 12;
          this.swiper.update();
        }

        cartUrl() {
          const button = this.querySelector('[data-sh-cs-cart]');
          return (button && button.getAttribute('data-cart-url')) || '/cart';
        }

        clearCartLockTimers() {
          (this._cartLockTimers || []).forEach((id) => window.clearTimeout(id));
          this._cartLockTimers = [];
        }

        closeActiveCart() {
          if (typeof window.upcartCloseCart === 'function') window.upcartCloseCart();
          const drawer = document.querySelector('cart-drawer');
          if (drawer && drawer.open && typeof drawer.hide === 'function') drawer.hide();
        }

        keepDrawerClosed() {
          this.clearCartLockTimers();
          window.__shCrossSellSkipDrawer = true;
          const hideDrawer = () => {
            if (!window.__shCrossSellSkipDrawer) return;
            this.closeActiveCart();
          };
          hideDrawer();
          this._cartLockTimers = [16, 50, 120, 250, 500, 800].map((ms) => window.setTimeout(hideDrawer, ms));
        }

        shouldSkipCart() {
          return Boolean(window.__shCrossSellSkipDrawer || document.body.classList.contains('sh-cross-sell-open'));
        }

        patchOpenCartFn() {
          if (typeof window.upcartOpenCart !== 'function') return;
          if (window.upcartOpenCart.__shPatched) return;
          const originalOpen = window.upcartOpenCart.bind(window);
          const patched = function () {
            if (window.__shCrossSellSkipDrawer || document.body.classList.contains('sh-cross-sell-open')) {
              return;
            }
            return originalOpen();
          };
          patched.__shPatched = true;
          patched.__shOriginal = originalOpen;
          window.upcartOpenCart = patched;
        }

        bindCartApps() {
          this.patchOpenCartFn();
          this.patchDrawer();

          if (!window.__shCrossSellUpcartOpenedBound && typeof window.upcartSubscribeCartOpened === 'function') {
            window.upcartSubscribeCartOpened(() => {
              if (this.shouldSkipCart()) this.closeActiveCart();
            });
            window.__shCrossSellUpcartOpenedBound = true;
          }

          if (!window.__shCrossSellUpcartAddedBound && typeof window.upcartSubscribeAddedToCart === 'function') {
            window.upcartSubscribeAddedToCart((event) => {
              this.onAdded({ item: event && event.item, detail: { product: event && event.item } });
            });
            window.__shCrossSellUpcartAddedBound = true;
          }

          if (!window.__shCrossSellUpcartUpdatedBound && typeof window.upcartSubscribeCartUpdated === 'function') {
            window.upcartSubscribeCartUpdated((event) => this.onCartEvent({ cart: event && event.cart }));
            window.__shCrossSellUpcartUpdatedBound = true;
          }
          if (!window.__shCrossSellUpcartLoadedBound && typeof window.upcartSubscribeCartLoaded === 'function') {
            window.upcartSubscribeCartLoaded((event) => this.onCartEvent({ cart: event && event.cart }));
            window.__shCrossSellUpcartLoadedBound = true;
          }
          if (!window.__shCrossSellUpcartRemovedBound && typeof window.upcartSubscribeItemRemoved === 'function') {
            window.upcartSubscribeItemRemoved(() => this.fetchCart());
            window.__shCrossSellUpcartRemovedBound = true;
          }

          return Boolean(
            window.__shCrossSellUpcartOpenedBound || window.__shCrossSellUpcartAddedBound
          );
        }

        onClick(event) {
          if (event.target.closest('[data-sh-cs-close]')) {
            event.preventDefault();
            this.close();
            return;
          }
          const cartButton = event.target.closest('[data-sh-cs-cart]');
          if (cartButton) {
            event.preventDefault();
            this.openCart(cartButton.getAttribute('data-cart-url') || '/cart');
          }
        }

        openCart(cartUrl) {
          this.clearCartLockTimers();
          window.__shCrossSellSkipDrawer = false;
          this.close();
          const originalOpen =
            window.upcartOpenCart && window.upcartOpenCart.__shOriginal
              ? window.upcartOpenCart.__shOriginal
              : null;
          window.setTimeout(() => {
            window.__shCrossSellSkipDrawer = false;
            document.body.classList.remove('sh-cross-sell-open');
            if (typeof originalOpen === 'function') {
              originalOpen();
              return;
            }
            if (typeof window.upcartOpenCart === 'function') {
              window.upcartOpenCart();
              return;
            }
            const drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.show === 'function') {
              drawer.show();
              return;
            }
            const icon = document.querySelector('[href$="/cart"], .header__icon--cart, [aria-controls="CartDrawer"]');
            if (icon) {
              icon.click();
              return;
            }
            window.location.href = cartUrl;
          }, 20);
        }

        patchDrawer() {
          const drawer = document.querySelector('cart-drawer');
          if (!drawer || drawer.__shCrossSellPatched) return;
          const original = drawer.show.bind(drawer);
          drawer.show = function () {
            if (window.__shCrossSellSkipDrawer || document.body.classList.contains('sh-cross-sell-open')) {
              return;
            }
            return original.apply(this, arguments);
          };
          drawer.__shCrossSellPatched = true;
        }

        open() {
          if (!this.hasOffers()) {
            this.openCart(this.cartUrl());
            return;
          }
          if (this.parentElement !== document.body) {
            this._moving = true;
            document.body.appendChild(this);
            this._moving = false;
          }
          this.hidden = false;
          document.body.classList.add('sh-cross-sell-open');
          requestAnimationFrame(() => {
            this.classList.add('is-open');
            if (this.swiper) {
              this.swiper.destroy(true, true);
              this.swiper = null;
            }
            this.initSwiper();
          });
          document.addEventListener('keydown', this.onKeydown);
          this.keepDrawerClosed();
          const closeBtn = this.querySelector('.sh-cross-sell__close');
          if (closeBtn) closeBtn.focus();
        }

        close() {
          this.clearCartLockTimers();
          this.classList.remove('is-open');
          this.hidden = true;
          window.__shCrossSellSkipDrawer = false;
          document.body.classList.remove('sh-cross-sell-open');
          document.removeEventListener('keydown', this.onKeydown);
        }

        onKeydown(event) {
          if (event.key === 'Escape') this.close();
        }

        loadSwiper() {
          if (window.Swiper) {
            this.initSwiper();
            return;
          }
          const existing = document.querySelector('script[data-sh-cs-swiper]');
          if (existing) {
            existing.addEventListener('load', () => this.initSwiper());
          }
          const wait = window.setInterval(() => {
            if (window.Swiper) {
              window.clearInterval(wait);
              this.initSwiper();
            }
          }, 50);
          window.setTimeout(() => window.clearInterval(wait), 8000);
        }

        initSwiper() {
          const el = this.querySelector('[data-sh-cs-swiper]');
          if (!el || !window.Swiper) return;
          const single = this.offerCount() <= 1;
          this.classList.toggle('is-single', single);
          if (this.swiper) {
            this.syncSingleLayout();
            return;
          }
          const pagination = this.querySelector('[data-sh-cs-pagination]');
          this.swiper = new window.Swiper(el, {
            slidesPerView: single ? 1 : 1.12,
            spaceBetween: single ? 0 : 12,
            grabCursor: !single,
            watchOverflow: true,
            resistanceRatio: 0.7,
            pagination: pagination
              ? {
                  el: pagination,
                  clickable: true,
                  bulletClass: 'sh-cross-sell__dot',
                  bulletActiveClass: 'is-active'
                }
              : undefined
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-final-cta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sh-final-cta')) {
    customElements.define(
      'sh-final-cta',
      class ShFinalCta extends HTMLElement {
        connectedCallback() {
          this.productId = String(this.dataset.productId || '');
          this.form = this.querySelector('form');
          this.priceEl = this.querySelector('[data-sh-fct-price]');
          this.compareEl = this.querySelector('[data-sh-fct-compare]');
          this.badgeEl = this.querySelector('[data-sh-fct-badge]');
          this.variantInput = this.querySelector('[data-sh-fct-variant]');
          this.qtyInput = this.querySelector('[data-sh-fct-qty]');
          this.button = this.querySelector('[data-sh-fct-button]');
          this.buttonLabel = this.querySelector('[data-sh-fct-button-label]');
          this.variants = this.readVariants();
          this.moneyFormat = this.readMoneyFormat();
          this.onVariantChange = this.onVariantChange.bind(this);
          this.onIdChange = this.onIdChange.bind(this);
          this.onQuantityEvent = this.onQuantityEvent.bind(this);
          this.onQtyPriceUpdate = this.onQtyPriceUpdate.bind(this);
          this.onFormSubmit = this.onFormSubmit.bind(this);
          this.pubsubTries = 0;

          this.bindPubsub();
          document.addEventListener('variant:change', this.onVariantChange, true);
          document.addEventListener('change', this.onIdChange, true);
          document.addEventListener('change', this.onQuantityEvent, true);
          document.addEventListener('input', this.onQuantityEvent, true);
          document.addEventListener('sh:qty-price-update', this.onQtyPriceUpdate);
          if (this.form) this.form.addEventListener('submit', this.onFormSubmit, true);
          this.syncFromMainForm();
          this.syncQuantity();
        }

        disconnectedCallback() {
          if (this.unsubscribeVariant) this.unsubscribeVariant();
          if (this.pubsubTimer) clearTimeout(this.pubsubTimer);
          document.removeEventListener('variant:change', this.onVariantChange, true);
          document.removeEventListener('change', this.onIdChange, true);
          document.removeEventListener('change', this.onQuantityEvent, true);
          document.removeEventListener('input', this.onQuantityEvent, true);
          document.removeEventListener('sh:qty-price-update', this.onQtyPriceUpdate);
          if (this.form) this.form.removeEventListener('submit', this.onFormSubmit, true);
        }

        readVariants() {
          const script = this.querySelector('[data-sh-fct-variants]');
          const map = {};
          if (!script) return map;
          try {
            const list = JSON.parse(script.textContent);
            if (Array.isArray(list)) {
              list.forEach((variant) => {
                if (variant && variant.id) map[String(variant.id)] = variant;
              });
            }
          } catch (error) {}
          return map;
        }

        readMoneyFormat() {
          const script = this.querySelector('[data-sh-fct-money-format]');
          if (script) {
            try {
              const parsed = JSON.parse(script.textContent);
              if (parsed) return String(parsed);
            } catch (error) {}
          }
          return this.dataset.moneyFormat || '';
        }

        bindPubsub() {
          if (this.unsubscribeVariant) return;
          if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
            this.unsubscribeVariant = theme.pubsub.subscribe(
              theme.pubsub.PUB_SUB_EVENTS.variantChange,
              this.onVariantChange
            );
            return;
          }
          if (this.pubsubTries > 40) return;
          this.pubsubTries += 1;
          this.pubsubTimer = setTimeout(() => this.bindPubsub(), 50);
        }

        onIdChange(event) {
          const input = event.target;
          if (!input || input.name !== 'id' || input.hasAttribute('data-sh-fct-variant')) return;
          if (input.closest('sh-final-cta')) return;
          this.applyVariantId(input.value);
        }

        syncFromMainForm() {
          const info = document.querySelector('product-info[data-product-id="' + this.productId + '"]');
          if (!info) return;
          const form = document.forms[info.getAttribute('form')];
          const input = form && form.querySelector('input[name="id"]');
          if (input) this.applyVariantId(input.value);
          this.syncQuantity();
        }

        getMainQuantity() {
          if (window.ShQtyPrice && typeof window.ShQtyPrice.getQuantity === 'function') {
            return window.ShQtyPrice.getQuantity(this.productId);
          }
          const info = document.querySelector('product-info[data-product-id="' + this.productId + '"]');
          const source =
            (info && info.querySelector('.sh-quantity-box input[name="quantity"]')) ||
            document.querySelector('.sh-quantity-box input[name="quantity"]');
          const qty = source ? Number(source.value || 0) : 1;
          return Number.isNaN(qty) || qty < 1 ? 1 : qty;
        }

        syncQuantity() {
          if (!this.qtyInput) return;
          this.qtyInput.value = String(this.getMainQuantity());
        }

        onQuantityEvent(event) {
          const input = event.target;
          if (!input || input.name !== 'quantity') return;
          if (input.hasAttribute('data-sh-fct-qty')) return;
          if (!input.closest('.sh-quantity-box')) return;
          const info = input.closest('product-info');
          if (info && this.productId && String(info.dataset.productId || '') !== this.productId) return;
          this.syncQuantity();
        }

        onQtyPriceUpdate(event) {
          const detail = (event && event.detail) || {};
          if (detail.productId && String(detail.productId) !== this.productId) return;
          this.syncQuantity();
        }

        onFormSubmit() {
          this.syncQuantity();
        }

        applyVariantId(variantId) {
          const variant = this.variants[String(variantId || '')];
          if (variant) this.applyVariant(variant);
        }

        onVariantChange(event) {
          const payload = event || {};
          const data = payload.data || payload.detail || {};
          const variant = data.variant;
          if (!variant || !variant.id) return;
          if (data.productId && String(data.productId) !== this.productId) return;
          const local = this.variants[String(variant.id)] || {};
          this.applyVariant(Object.assign({}, local, variant));
        }

        applyVariant(variant) {
          const price = Number(variant.price || 0);
          const compare = Number(variant.compare_at_price || 0);
          this.dataset.comparePrice = String(compare);
          const onSale = compare > price;
          const available = variant.available === true;

          if (this.priceEl) this.priceEl.textContent = this.formatMoney(price);

          if (this.compareEl) {
            this.compareEl.textContent = this.formatMoney(compare);
            this.compareEl.classList.toggle('hidden', !(this.dataset.showCompare === 'true' && onSale));
          }

          if (this.badgeEl) {
            const showBadge = this.dataset.showBadge === 'true' && onSale;
            if (showBadge) this.badgeEl.textContent = this.buildBadge(compare - price);
            this.badgeEl.classList.toggle('hidden', !showBadge);
          }

          if (this.variantInput && variant.id) this.variantInput.value = variant.id;

          if (this.button) this.button.disabled = !available;
          if (this.buttonLabel) {
            this.buttonLabel.textContent = available
              ? this.dataset.buttonLabel || ''
              : this.dataset.soldOut || '';
          }

          this.classList.toggle('sh-final-cta--on-sale', onSale);
        }

        buildBadge(savingsCents) {
          const amount = this.formatMoney(savingsCents, true);
          const template = this.dataset.badgeText || '';
          if (template.indexOf('[amount]') !== -1) {
            return template.split('[amount]').join(amount);
          }
          if (template) return `${template} ${amount}`.trim();
          return amount;
        }

        formatMoney(cents, stripZeros) {
          let value = cents;
          if (typeof value === 'string') value = value.replace('.', '');
          value = Number(value || 0);

          const format = this.moneyFormat || this.dataset.moneyFormat || '';
          const placeholder = /\{\{\s*(\w+)\s*\}\}/;
          const match = String(format).match(placeholder);
          const token = match ? match[1] : 'amount_with_comma_separator';

          let precision = 2;
          let thousands = ',';
          let decimal = '.';

          if (token.indexOf('no_decimals') !== -1) precision = 0;
          if (token.indexOf('comma_separator') !== -1) {
            thousands = '.';
            decimal = ',';
          } else if (token.indexOf('space_separator') !== -1) {
            thousands = ' ';
          } else if (token.indexOf('apostrophe_separator') !== -1) {
            thousands = "'";
          }

          if (stripZeros && value % 100 === 0) precision = 0;

          const fixed = (value / 100).toFixed(precision);
          const parts = fixed.split('.');
          parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
          const amount = parts[1] ? parts[0] + decimal + parts[1] : parts[0];

          if (match) return String(format).replace(placeholder, amount);
          return amount + ' €';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-free-order-infos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.shFoiModalInit) return;
    window.shFoiModalInit = true;

    function openModal(modal, trigger) {
      if (!modal || modal.open) return;
      modal._shFoiTrigger = trigger;
      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
      document.documentElement.style.overflow = 'hidden';
    }

    function closeModal(modal) {
      if (!modal) return;
      if (typeof modal.close === 'function' && modal.open) {
        modal.close();
      } else {
        modal.removeAttribute('open');
        onClosed(modal);
      }
    }

    function onClosed(modal) {
      document.documentElement.style.overflow = '';
      if (modal._shFoiTrigger) modal._shFoiTrigger.focus();
    }

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-sh-foi-open]');
      if (opener) {
        openModal(document.getElementById(opener.dataset.shFoiOpen), opener);
        return;
      }

      var closer = event.target.closest('[data-sh-foi-close]');
      if (closer) {
        closeModal(closer.closest('[data-sh-foi-modal]'));
        return;
      }

      // Click on the backdrop closes the dialog.
      if (event.target.matches && event.target.matches('[data-sh-foi-modal]')) {
        closeModal(event.target);
      }
    });

    document.addEventListener(
      'close',
      function (event) {
        if (event.target.matches && event.target.matches('[data-sh-foi-modal]')) onClosed(event.target);
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-order-cta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sh-order-cta')) {
    customElements.define(
      'sh-order-cta',
      class ShOrderCta extends HTMLElement {
        connectedCallback() {
          this.productId = String(this.dataset.productId || '');
          this.priceEl = this.querySelector('[data-sh-oc-price]');
          this.compareEl = this.querySelector('[data-sh-oc-compare]');
          this.badgeEl = this.querySelector('[data-sh-oc-badge]');
          this.scrollButton = this.querySelector('[data-sh-oc-scroll]');

          this.onVariantChange = this.onVariantChange.bind(this);
          this.onScrollClick = this.onScrollClick.bind(this);

          if (window.theme && theme.pubsub) {
            this.unsubscribeVariant = theme.pubsub.subscribe(
              theme.pubsub.PUB_SUB_EVENTS.variantChange,
              this.onVariantChange
            );
          }

          document.addEventListener('variant:change', this.onVariantChange);
          if (this.scrollButton) {
            this.scrollButton.addEventListener('click', this.onScrollClick);
          }
        }

        disconnectedCallback() {
          if (this.unsubscribeVariant) this.unsubscribeVariant();
          document.removeEventListener('variant:change', this.onVariantChange);
          if (this.scrollButton) {
            this.scrollButton.removeEventListener('click', this.onScrollClick);
          }
        }

        onVariantChange(event) {
          const data = (event && event.data) || (event && event.detail) || {};
          const variant = data.variant;
          if (!variant) return;
          if (data.productId && String(data.productId) !== this.productId) return;
          this.applyVariant(variant);
        }

        applyVariant(variant) {
          const price = Number(variant.price || 0);
          const compare = Number(variant.compare_at_price || 0);
          this.dataset.comparePrice = String(compare);
          const onSale = compare > price;

          if (this.priceEl) this.priceEl.textContent = this.formatMoney(price);

          if (this.compareEl) {
            this.compareEl.textContent = this.formatMoney(compare);
            this.compareEl.classList.toggle('hidden', !(this.dataset.showCompare === 'true' && onSale));
          }

          if (this.badgeEl) {
            const showBadge = this.dataset.showBadge === 'true' && onSale;
            if (showBadge) {
              this.badgeEl.textContent = this.buildBadge(compare - price);
            }
            this.badgeEl.classList.toggle('hidden', !showBadge);
          }

          this.classList.toggle('sh-order-cta--on-sale', onSale);
        }

        buildBadge(savingsCents) {
          const amount = this.formatMoney(savingsCents, true);
          const template = this.dataset.badgeText || '';
          if (template.indexOf('[amount]') !== -1) {
            return template.split('[amount]').join(amount);
          }
          if (template) return `${template} ${amount}`.trim();
          return amount;
        }

        formatMoney(cents, stripZeros) {
          const format = this.dataset.moneyFormat || '';
          let formatted = String(cents);
          if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
            formatted = theme.Currency.formatMoney(cents, format);
          }
          if (stripZeros && Number(cents) % 100 === 0) {
            formatted = formatted.replace(/([.,]00)(?=\D|$)/, '');
          }
          return formatted;
        }

        onScrollClick(event) {
          event.preventDefault();
          const selector = this.dataset.scrollSelector || '#sh-main-atc';
          let target = document.querySelector(selector);
          if (!target || !target.matches('button, [type="submit"], .product-form__submit')) {
            target =
              document.querySelector('#sh-main-atc') ||
              document.querySelector('.sh-pdp .product-form__submit') ||
              document.querySelector('.sh-pdp form.product-form [name="add"]');
          }
          if (!target) return;

          const header = document.querySelector('sticky-header, #shopify-section-header');
          const headerOffset = header ? header.getBoundingClientRect().height : 0;
          const extra = Number(this.dataset.scrollOffset || 0);
          const top =
            target.getBoundingClientRect().top +
            window.scrollY -
            headerOffset -
            extra -
            Math.round(window.innerHeight * 0.28);
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });

          const focusAtc = () => {
            if (typeof target.focus === 'function') {
              target.focus({ preventScroll: true });
            }
          };

          if ('onscrollend' in window) {
            window.addEventListener('scrollend', focusAtc, { once: true });
          } else {
            window.setTimeout(focusAtc, 450);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-product-features"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sh-product-features')) {
    customElements.define(
      'sh-product-features',
      class ShProductFeatures extends HTMLElement {
        connectedCallback() {
          this.querySelectorAll('video').forEach((video) => {
            video.muted = true;
            video.defaultMuted = true;
            video.playsInline = true;
            video.setAttribute('playsinline', '');
            video.setAttribute('muted', '');
            const play = () => {
              video.play().catch(() => {});
            };
            if (typeof Motion !== 'undefined' && Motion.inView) {
              Motion.inView(video, play);
            } else {
              play();
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!document.querySelector('script[data-sh-reviews-trustpilot]')) {
    var shReviewsScript = document.createElement('script');
    shReviewsScript.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    shReviewsScript.async = true;
    shReviewsScript.setAttribute('data-sh-reviews-trustpilot', 'true');
    document.head.appendChild(shReviewsScript);
  }

  } catch(e) { console.error(e); }
})();
})();
